import React from 'react';

export default function DashboardElearningComponent() {
  return (
    <div className="containerDescDashboardElearning">
      <div>Selamat Datang di CMS e-Learning My Zurich Apps</div>
    </div>
  );
}
